export interface FilterSuggestion {
  id: number;
  criteria: Record<string, any>;
  label: string;
  // Measured by the server when the filter was proposed. null means "not
  // measured", not "no hits"; capped means the index counts no further.
  total?: number | null;
  capped?: boolean;
  created: string;
}

export interface WorkspaceMessage {
  id?: number;
  role: "user" | "assistant";
  content: string;
  finished: boolean;
  created?: string;
  filters: FilterSuggestion[];
  researchProposals: ResearchProposal[];
  reportProposals: ReportProposal[];
}

// Het model stelde een gespreksrapport voor; `fileUrl` is er zodra de PDF is gemaakt.
export interface ReportProposal {
  id: number;
  title: string;
  situation: string;
  conclusion: string;
  fileId?: number | null;
  fileUrl?: string | null;
  // "" (nooit gevraagd), queued, running, done, failed — de PDF wordt in een
  // Celery-taak gemaakt; zolang hij queued/running is pollt de kaart.
  pdfStatus?: PdfStatus;
  pdfError?: string;
  created: string;
}

export type PdfStatus = "" | "queued" | "running" | "done" | "failed";

export const pdfPending = (status?: PdfStatus) => status === "queued" || status === "running";

export interface ResearchProposal {
  id: number;
  parcelId: number;
  parcelName: string;
  extraQuestion: string;
  researchId?: number | null;
  created: string;
}

export interface ChatSessionSummary {
  id: number;
  title: string;
  created: string;
  modified: string;
  messageCount: number;
}

export interface ChatSessionDetail extends ChatSessionSummary {
  messages: WorkspaceMessage[];
}
